module.exports = __webpack_public_path__ + "a5f6627445942756ed36cf989d55cbeb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers/book-2.png
// module id = 3402
// module chunks = 0